import PurchaseOrderVendorTypes from './POVTypes';

export const getVendorPurchaseOrderListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_PROGRESS,
  };
};

export const getVendorPurchaseOrderListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_SUCCESS,
  };
};

export const getVendorPurchaseOrderListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_PURCHASE_ORDER_LIST_ERROR,
  };
};

export const getPOInfoInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PO_INFO_PROGRESS,
  };
};

export const getPOInfoInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PO_INFO_ERROR,
  };
};

export const getPOInfoInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PO_INFO_SUCCESS,
  };
};

export const setPoInfoDefault = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_PO_INFO_DEFAULT,
  };
};

export const getPackagesInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_PROGRESS,
  };
};

export const getPackagesInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_ERROR,
  };
};

export const getPackagesInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_PACKAGE_INFO_SUCCESS,
  };
};

export const regularOrdersResetValue = () => {
  return {
    type: PurchaseOrderVendorTypes.REGULAR_ORDER_DATA_RESET,
  };
};

export const saveRegularOrdersInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_PROGRESS,
  };
};

export const saveRegularOrdersInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_ERROR,
  };
};

export const saveRegularOrdersInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_REGULAR_ORDER_DATA_SUCCESS,
  };
};

export const setPackageModal = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_PACKAGE_MODAL_TOGGLE,
  };
};

export const savePackageInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_PROGRESS,
  };
};

export const savePackageInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_ERROR,
  };
};

export const savePackageInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_PACKAGE_DETAILS_SUCCESS,
  };
};

export const saveShipmentInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_PROGRESS,
  };
};

export const saveShipmentInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_ERROR,
  };
};

export const saveShipmentInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_SHIPMENT_DETAILS_SUCCESS,
  };
};

export const setTotalPurchaseOrderCount = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_PURCHASE_ORDER_TOTAL_COUNT,
  };
};

export const setVendorPurchaseOrderList = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_VENDOR_PURCHASE_ORDER_LIST,
  };
};

export const getVendorShipperListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_PROGRESS,
  };
};

export const getVendorShipperListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_SUCCESS,
  };
};

export const getVendorShipperListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPPER_LIST_ERROR,
  };
};

export const getVendorConsigneeListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_PROGRESS,
  };
};

export const getVendorConsigneeListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_SUCCESS,
  };
};

export const getVendorConsigneeListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_CONSIGNEE_LIST_ERROR,
  };
};
export const getVendorShipmentDetailListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_PROGRESS,
  };
};

export const getVendorShipmentDetailListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_SUCCESS,
  };
};

export const getVendorShipmentDetailListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_DETAIL_LIST_ERROR,
  };
};

export const getVendorShipmentItemDetailListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_PROGRESS,
  };
};

export const getVendorShipmentItemDetailListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_SUCCESS,
  };
};

export const getVendorShipmentItemDetailListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_ERROR,
  };
};

export const getBarCode = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_BAR_CODE,
  };
};

export const getBarCodeSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_BAR_CODE_SUCCESS,
  };
};

export const getBarCodeError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_BAR_CODE_Fail,
  };
};

export const getVendorShipmentSummaryListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_PROGRESS,
  };
};

export const getVendorShipmentSummaryListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_SUCCESS,
  };
};

export const getVendorShipmentSummaryListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_SUMMARY_LIST_ERROR,
  };
};

export const getVendorShipmentLadingListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_PROGRESS,
  };
};

export const getVendorShipmentLadingListInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_SUCCESS,
  };
};

export const getVendorShipmentLadingListInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_VENDOR_SHIPMENT_LADING_LIST_ERROR,
  };
};

export const setSelectedShipper = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPPER,
  };
};

export const setSelectedConsignee = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SELECTED_CONSIGNEE,
  };
};

export const createShipmentInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_PROGRESS,
  };
};

export const createShipmentInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_ERROR,
  };
};

export const createShipmentInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_SUCCESS,
  };
};

export const createShipmentInReset = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CREATE_SHIPMENT_RESET,
  };
};

export const setPayloadShipData = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_PAYLOAD_SHIP_DATA,
  };
};

export const getRoutingGuideInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE,
  };
};

export const getRoutingGuideInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE_ERROR,
  };
};

export const getRoutingGuideInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_ROUTING_GUIDE_SUCCESS,
  };
};

export const setSelectedShipmentItemDetail = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPMENT_ITEM_DETAIL,
  };
};

export const setSelectedShipmentSummary = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SELECTED_SHIPMENT_SUMMARY,
  };
};

export const saveVendorAddressInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_PROGRESS,
  };
};

export const saveVendorAddressInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_ERROR,
  };
};

export const saveVendorAddressInSuccess = () => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_SUCCESS,
  };
};

export const saveVendorAddressInReset = () => {
  return {
    type: PurchaseOrderVendorTypes.SAVE_VENDOR_ADDRESS_RESET,
  };
};

export const setSaveShipmentData = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SAVE_SHIPMENT_DATA,
  };
};

export const cancelShipmentInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_PROGRESS,
  };
};

export const cancelShipmentInError = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_ERROR,
  };
};

export const cancelShipmentInSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.CANCEL_SHIPMENT_SUCCESS,
  };
};

export const getVendorSearchRequest = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH };
};

export const getVendorSearchSuccess = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_SUCCESS };
};

export const getVendorSearchFail = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_FAIL };
};

export const getVendorSearchClear = () => {
  return { type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_CLEAR };
};

export const getVendorSearchUpdate = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_UPDATE };
};

export const updateVendorSearchFilter = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.GET_VENDOR_SEARCH_FILTER };
};

export const deleteVendorAddressRequest = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS };
};

export const deleteVendorAddressSuccess = () => {
  return {
    type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_SUCCESS,
  };
};

export const deleteVendorAddressFail = (payload) => {
  return { payload, type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_FAIL };
};

export const deleteVendorAddressReset = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.DELETE_VENDOR_ADDRESS_RESET,
  };
};

export const addVendorRecord = () => {
  return { type: PurchaseOrderVendorTypes.ADD_VENDOR_ADDRESS_RECORD };
};

export const setSelectAllItemsPOV = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.SET_SELECT_ALL_CHECK_POV,
  };
};

export const removeVendorSummaryList = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.REMOVE_VENDOR_SUMMARY_LIST,
  };
};

export const getCustomerRouterSettingInprogress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING,
  };
};

export const getCustomerRouterSettingSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING_SUCCESS,
  };
};

export const getCustomerRouterSettingFail = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.GET_CUSTOMER_ROUTING_SETTING_FAIL,
  };
};

export const resetOrderListInProgress = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST,
  };
};

export const resetOrderListSuccess = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST_SUCCESS,
  };
};

export const resetOrderListFail = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.RESET_ORDER_LIST_FAIL,
  };
};

export const packageLoadTypeActionHandler = (payload) => {
  return {
    payload,
    type: PurchaseOrderVendorTypes.PACKAGE_LOAD_TYPE_DATA,
  };
};
